import React, { useEffect, useState } from "react";
import { Box, Typography, Button, styled } from "@mui/material";
import AssistantSelection from "../components/pages/settings/cards/AssistantCard";
import LanguageSelector from "./shared/LanguageSelector";
import { useTranslation } from "react-i18next";

const Overlay = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 1300,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.8)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const IntroBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#fff",
  padding: "2rem",
  borderRadius: "12px",
  minWidth: "450px",
  maxWidth: "1420px",
  maxHeight: "95vh",
  overflowY: "auto", 
  overflow: "hidden",
  boxShadow: "0 0 30px rgba(0,0,0,0.2)",
  textAlign: "center",
  [theme.breakpoints.down("lg")]: {
    transform: "scale(0.7)",
  },
  [theme.breakpoints.down("md")]: {
    transform: "scale(0.85)",
  },
  [theme.breakpoints.down("sm")]: {
    transform: "scale(0.8)",
    padding: "1rem",
  },
}));

const StepTwoWrapper = styled(Box)<{ scale: number }>(({ scale }) => ({
  transform: `scale(${scale})`,
  transformOrigin: "top center",
  transition: "transform 0.3s ease",
}));


const StartButton = styled(Button)({
  marginTop: "1.5rem",
  backgroundColor: "#8CA895",
  color: "#fff",
  padding: "0.8rem 2rem",
  fontWeight: 600,
  borderRadius: "8px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#789781",
  },
});

interface Props {
  onComplete: () => void;
}

const IntroOverlay: React.FC<Props> = ({ onComplete }) => {
  const [step, setStep] = useState(1);
  const [canContinue, setCanContinue] = useState(false);
  const {t}=useTranslation();
  const [scale, setScale] = useState(1);

useEffect(() => {
  const updateScale = () => {
    const height = window.innerHeight;
    if (height < 600) setScale(0.6);
    else if (height < 900) setScale(0.7);
    else setScale(0.9);
  };

  updateScale();
  window.addEventListener("resize", updateScale);
  return () => window.removeEventListener("resize", updateScale);
}, []);

  useEffect(() => {
    if (step === 2) {
      const interval = setInterval(() => {
        const avatar = localStorage.getItem("selectedAvatar");
        setCanContinue(!!avatar);
      }, 300);
      return () => clearInterval(interval);
    } else {
      setCanContinue(true);
    }
  }, [step]);

  return (
    <Overlay>
      <IntroBox>
        {step === 1 && (
          <>
            <Typography variant="h6" fontWeight={700}> {t("intro.language")}</Typography>
            <Box mt={2}><LanguageSelector /></Box>
            <StartButton onClick={() => setStep(2)}>{t("Weiter")}</StartButton>
          </>
        )}

        {step === 2 && (
          <>
<StepTwoWrapper scale={scale}>
          <Typography variant="h6" fontWeight={700}>{t("intro.avatarTitle")}</Typography>
          <Typography mt={1}>{t("intro.avatarDescription")}</Typography>
            <Box
           sx={{
             display: "flex",
             flexWrap: "wrap",
             justifyContent: "center",
             gap: "1.5rem",
             width: "100%",
           }}
            >         
            <AssistantSelection/>
            </Box>

            <StartButton
      disabled={!canContinue}
      onClick={() => setStep(3)}
    >
      {t("intro.next")}
    </StartButton>
    </StepTwoWrapper>
          </>
        )}

        {step === 3 && (
          <>
            <Typography variant="h6" fontWeight={700}>{t("intro.readyTitle")}</Typography>
            <Typography mt={1}>{t("intro.readyDescription")}</Typography>
            <StartButton onClick={onComplete}>{t("intro.startTour")}</StartButton>
          </>
        )}
      </IntroBox>
    </Overlay>
  );
};

export default IntroOverlay;
